import { ScoreType } from '../../../../../../store/admin/eventFormats/store';
import { TIFormatPrefix } from '../../../../../../store/admin/roundFormats/store';
import { IResult } from '../../../../../../store/admin/roundResults/store';

import { getResultField } from './getResultField';
import { isResultTied } from './isResultTied';

export const getResultPosition = (
  result: IResult,
  prefix: TIFormatPrefix,
  scoreType: ScoreType,
  considerFlight: boolean,
  showNoPosition?: boolean,
  formatIsStableFord?: boolean
) => {
  if (showNoPosition) {
    return '-';
  }

  if (prefix === 'skins') {
    return Number(result.hole) + 1;
  }

  const isHorse = prefix === 'horse';

  const tiedIndicator = !isHorse && isResultTied(result, prefix, scoreType) ? 'T' : '';

  const positionField = getResultField(
    result,
    isHorse ? 'Hole' : 'Position',
    prefix,
    scoreType,
    considerFlight,
    formatIsStableFord
  );

  return `${tiedIndicator}${
    positionField === undefined ? '-' : Number(positionField) + (isHorse ? 1 : 0)
  }`;
};
